export default __webpack_public_path__ + "static/media/DSC04809.e8f33cdf.jpg";